import { apiCall } from './_helper';

// Tests whether a EORI number is valid
// Tested and working: 4/6/2025
export const getEORIValidation = async (eoriNumber, GBOnly) => {
  return await apiCall({
    url: `eori/eori?eori=${encodeURIComponent(eoriNumber)}&GBOnly=${GBOnly}`,
    notJSON: true,
  });
};

// Gets a list of countries. Used in other places besides registration
// Tested and working: 4/6/2025
export const fetchCountryData = async () => {
  return await apiCall({
    url: 'registration/countries',
    notJSON: true,
  });
};

// Returns a list of statuses for jobs and their associated ids
// Tested and working: 4/6/2025
export const getStatusReference = async () => {
  return await apiCall({
    url: 'referencedata/getStatusReference',
    notJSON: true,
  });
};

// Gets reference data for ENS Declaration process
// Tested and working: 4/6/2025
export const getReferenceData = async (urlParam) => {
  return await apiCall({
    url: `referencedata/${urlParam}`,
    notJSON: true,
  });
};

// Gets a list of consignors for the ENS Declaration process
// Tested and working: 4/6/2025
export const getConsignors = async (companyId = parseInt(sessionStorage.getItem('companyid'))) => {
  return await apiCall({
    url: `traders/traderList?companyId=${companyId}&type=consignor`,
    notJSON: true,
  });
};

// Gets a list of consignees for the ENS Declaration process
// Tested and working: 4/6/2025
export const getConsignees = async (companyId = parseInt(sessionStorage.getItem('companyid'))) => {
  return await apiCall({
    url: `traders/traderList?companyId=${companyId}&type=consignee`,
    notJSON: true,
  });
};

export const fetchCustomerType = async () => {
  return await apiCall({
    url: 'referencedata/customerTypes',
    notJSON: true,
  });
};
